import { render, staticRenderFns } from "./CustomWishListCount.vue?vue&type=template&id=563f0ee2&"
import script from "./CustomWishListCount.vue?vue&type=script&lang=js&"
export * from "./CustomWishListCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nsierrar/Projects/PlentyMarkets/Repo-GitHub/MultiContentWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563f0ee2')) {
      api.createRecord('563f0ee2', component.options)
    } else {
      api.reload('563f0ee2', component.options)
    }
    module.hot.accept("./CustomWishListCount.vue?vue&type=template&id=563f0ee2&", function () {
      api.rerender('563f0ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/wishList/CustomWishListCount.vue"
export default component.exports